<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportNgs"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="filterControlCardNumbers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card Number " id="filter-" size="sm" :model.sync="filter.filterControlCardNumber" @input="getFilterControlCardNumbers" @focus="getFilterControlCardNumbers" />
					<app-input-combobox-autocomplete :options="filterPartNumbers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Number " id="filter-" size="sm" :model.sync="filter.filterPartNumber" @input="getFilterPartNumbers" @focus="getFilterPartNumbers" />
					<app-input-combobox-autocomplete :options="filterMachines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine " id="filter-" size="sm" :model.sync="filter.filterMachine" @input="getFilterMachines" @focus="getFilterMachines" />
					<app-input-combobox-autocomplete :options="filterSubprocesss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Subprocess " id="filter-" size="sm" :model.sync="filter.filterSubprocess" @input="getFilterSubprocesss" @focus="getFilterSubprocesss" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
					<app-input-combobox-autocomplete :options="filterLines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Line " id="filter-" size="sm" :model.sync="filter.filterLine" @input="getFilterLines" @focus="getFilterLines" />
					<app-input-combobox-autocomplete :options="filterPartClassifications" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Classification " id="filter-" size="sm" :model.sync="filter.filterPartClassification" @input="getFilterPartClassifications" @focus="getFilterPartClassifications" />
					<app-input-datepicker-range  id="fieldset-filter-period-date" label-cols-sm="4" label-cols-lg="3" label="Period Date " size="sm" :modelFrom.sync="filter.filterPeriodDateFrom" :modelTo.sync="filter.filterPeriodDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportNgs"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Ng</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reportng" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportNgs" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportNgs.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Created Date" class="table-filter">
					<!-- <b-form-input id="input-created-date-table" @input="getReportNgsWithoutLoading" v-model="filter.createdDate" size="sm"></b-form-input> -->
					<app-input-datepicker-range @change="getReportNgsWithoutLoading" id="fieldset-filter-period-date" label-cols-sm="4" label-cols-lg="3" label="Period Date " size="sm" :modelFrom.sync="filter.filterPeriodDateFrom" :modelTo.sync="filter.filterPeriodDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
				</b-th>
				<b-th stacked-heading="Part Name" class="table-filter">
					<!-- <b-form-input id="input-part-name-table" @input="getReportNgsWithoutLoading" v-model="filter.partName" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Part Number" class="table-filter">
					<!-- <b-form-input id="input-part-number-table" @input="getReportNgsWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input> -->
					<app-input-combobox-autocomplete @change="getReportNgsWithoutLoading" :options="filterPartNumbers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Number " id="filter-" size="sm" :model.sync="filter.filterPartNumber" @input="getFilterPartNumbers" @focus="getFilterPartNumbers" />
				</b-th>
				<b-th stacked-heading="Control Card Number" class="table-filter">
					<!-- <b-form-input id="input-control-card-number-table" @input="getReportNgsWithoutLoading" v-model="filter.controlCardNumber" size="sm"></b-form-input> -->
					<app-input-combobox-autocomplete @change="getReportNgsWithoutLoading" :options="filterControlCardNumbers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card Number " id="filter-" size="sm" :model.sync="filter.filterControlCardNumber" @input="getFilterControlCardNumbers" @focus="getFilterControlCardNumbers" />
				</b-th>
				<b-th stacked-heading="Customer Name" class="table-filter">
					<!-- <b-form-input id="input-customer-name-table" @input="getReportNgsWithoutLoading" v-model="filter.customerName" size="sm"></b-form-input> -->
					<app-input-combobox-autocomplete @change="getReportNgsWithoutLoading" :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
				</b-th>
				<b-th stacked-heading="Part Specification" class="table-filter">
					<!-- <b-form-input id="input-part-specification-table" @input="getReportNgsWithoutLoading" v-model="filter.partSpecification" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Shift" class="table-filter">
					<!-- <b-form-input id="input-shift-table" @input="getReportNgsWithoutLoading" v-model="filter.shift" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Line Production" class="table-filter">
					<!-- <b-form-input id="input-line-production-table" @input="getReportNgsWithoutLoading" v-model="filter.lineProduction" size="sm"></b-form-input> -->
					<app-input-combobox-autocomplete @change="getReportNgsWithoutLoading" :options="filterLines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Line " id="filter-" size="sm" :model.sync="filter.filterLine" @input="getFilterLines" @focus="getFilterLines" />
				</b-th>
				<b-th stacked-heading="Machine Name" class="table-filter">
					<!-- <b-form-input id="input-machine-name-table" @input="getReportNgsWithoutLoading" v-model="filter.machineName" size="sm"></b-form-input> -->
					<app-input-combobox-autocomplete @change="getReportNgsWithoutLoading" :options="filterMachines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine " id="filter-" size="sm" :model.sync="filter.filterMachine" @input="getFilterMachines" @focus="getFilterMachines" />
				</b-th>
				<b-th stacked-heading="Sub Process" class="table-filter">
					<!-- <b-form-input id="input-subprocess-table" @input="getReportNgsWithoutLoading" v-model="filter.subprocess" size="sm"></b-form-input> -->
					<app-input-combobox-autocomplete @change="getReportNgsWithoutLoading" :options="filterSubprocesss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Subprocess " id="filter-" size="sm" :model.sync="filter.filterSubprocess" @input="getFilterSubprocesss" @focus="getFilterSubprocesss" />
				</b-th>
				<b-th stacked-heading="Part Classification" class="table-filter">
					<!-- <b-form-input id="input-part-classification-table" @input="getReportNgsWithoutLoading" v-model="filter.partClassification" size="sm"></b-form-input> -->
					<app-input-combobox-autocomplete @change="getReportNgsWithoutLoading" :options="filterPartClassifications" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Classification " id="filter-" size="sm" :model.sync="filter.filterPartClassification" @input="getFilterPartClassifications" @focus="getFilterPartClassifications" />
				</b-th>
				<!-- <b-th stacked-heading="Qty Case" class="table-filter">
					<b-form-input id="input-qty-case-table" @input="getReportNgsWithoutLoading" v-model="filter.qtyCase" size="sm"></b-form-input>
				</b-th> -->
				<b-th stacked-heading="NG Code" class="table-filter">
					<!-- <b-form-input id="input-code-table" @input="getReportNgsWithoutLoading" v-model="filter.code" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Rack Name" class="table-filter">
					<!-- <b-form-input id="input-name-table" @input="getReportNgsWithoutLoading" v-model="filter.name" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Area Name" class="table-filter">
					<!-- <b-form-input id="input-area-name-table" @input="getReportNgsWithoutLoading" v-model="filter.areaName" size="sm"></b-form-input> -->
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:head(frontAction)>
						<div class="d-flex justify-content-center ml-2">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
								<b-icon-funnel />
							</b-button>
						</div>
					</template>
					
					<template v-slot:cell(createdDate)="row">
						{{ row.item.createdDate | moment("DD-MMM-YYYY") }}
					</template>

					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-part-number" label-cols-lg="12"  label="Part Number" label-for="input-part-number" size="sm" :model.sync="row.item.partNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-control-card-number" label-cols-lg="12"  label="Control Card Number" label-for="input-control-card-number" size="sm" :model.sync="row.item.controlCardNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-customer-name" label-cols-lg="12"  label="Customer Name" label-for="input-customer-name" size="sm" :model.sync="row.item.customerName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-specification" label-cols-lg="12"  label="Part Specification" label-for="input-part-specification" size="sm" :model.sync="row.item.partSpecification"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-shift" label-cols-lg="12"  label="Shift" label-for="input-shift" size="sm" :model.sync="row.item.shift"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-line-production" label-cols-lg="12"  label="Line Production" label-for="input-line-production" size="sm" :model.sync="row.item.lineProduction"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-machine-name" label-cols-lg="12"  label="Machine Name" label-for="input-machine-name" size="sm" :model.sync="row.item.machineName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-subprocess" label-cols-lg="12"  label="Sub Process" label-for="input-subprocess" size="sm" :model.sync="row.item.subprocess"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-classification" label-cols-lg="12"  label="Part Classification" label-for="input-part-classification" size="sm" :model.sync="row.item.partClassification"   :isEditable="false" :isUpdatable="true" />
						<!-- <app-input-textbox id="fieldset-qty-case" label-cols-lg="12"  label="Qty Case" label-for="input-qty-case" size="sm" :model.sync="row.item.qtyCase"   :isEditable="false" :isUpdatable="true" /> -->
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="NG Code" label-for="input-code" size="sm" :model.sync="row.item.code"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Rack Name" label-for="input-name" size="sm" :model.sync="row.item.name"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-area-name" label-cols-lg="12"  label="Area Name" label-for="input-area-name" size="sm" :model.sync="row.item.areaName"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportNgsPaging != null ? reportNgsPaging.dataCount : 0)"
											  :per-page="(reportNgsPaging != null ? reportNgsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportng.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportng.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportNg from '@/models/ReportNg/ReportNg';
import ReportNgList from '@/models/ReportNg/ReportNgList';
import ReportNgFilter from '@/filters/ReportNg/ReportNgFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportNg, 
		ReportNgList, 
		ReportNgFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"frontAction" : {"class" : "th-number d-stack-none"}},
				{"createdDate": {}, "class" : "th-created-date first-child", "label" : "Created Date", key: 'createdDate', }, 
				{"partName": {}, "class" : "th-part-name", "label" : "Part Name", key: 'partName', }, 
				{"partNumber": {}, "class" : "th-part-number last-child", "label" : "Part Number", key: 'partNumber', }, 
				{"controlCardNumber": {}, "class" : "th-control-card-number d-stack-none", "label" : "Control Card Number", key: 'controlCardNumber', }, 
				{"customerName": {}, "class" : "th-customer-name d-stack-none", "label" : "Customer Name", key: 'customerName', }, 
				{"partSpecification": {}, "class" : "th-part-specification d-stack-none", "label" : "Part Specification", key: 'partSpecification', }, 
				{"shift": {}, "class" : "th-shift d-stack-none", "label" : "Shift", key: 'shift', }, 
				{"lineProduction": {}, "class" : "th-line-production d-stack-none", "label" : "Line Production", key: 'lineProduction', }, 
				{"machineName": {}, "class" : "th-machine-name d-stack-none", "label" : "Machine Name", key: 'machineName', }, 
				{"subprocess": {}, "class" : "th-subprocess d-stack-none", "label" : "Sub Process", key: 'subprocess', }, 
				{"partClassification": {}, "class" : "th-part-classification d-stack-none", "label" : "Part Classification", key: 'partClassification', }, 
				//{"qtyCase": {}, "class" : "th-qty-case d-stack-none", "label" : "Qty Case", key: 'qtyCase', }, 
				{"qtyNg": {}, "class" : "th-qty-ng d-stack-none", "label" : "Qty NG", key: 'qtyNg', }, 
				{"code": {}, "class" : "th-code d-stack-none", "label" : "NG Code", key: 'code', }, 
				{"name": {}, "class" : "th-name d-stack-none", "label" : "NG Name", key: 'name', }, 
				{"areaName": {}, "class" : "th-area-name d-stack-none", "label" : "Area Name", key: 'areaName', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportNgs: [],
			reportNgsPaging: {},
			filterControlCardNumbers : [],
			filterPartNumbers : [],
			filterMachines : [],
			filterSubprocesss : [],
			filterCustomers : [],
			filterLines : [],
			filterPartClassifications : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
		}
	},	methods : {
		getReportNgs : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportNg.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportNgs = result.data
					this.reportNgsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportNgsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportNg.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportNgs = result.data
					this.reportNgsPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterControlCardNumbers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportNg.getListCustomUrl(this,'getlistfiltercontrolcardnumber' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterControlCardNumbers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterPartNumbers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportNg.getListCustomUrl(this,'getlistfilterpartnumber' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterPartNumbers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterMachines : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportNg.getListCustomUrl(this,'getlistfiltermachine' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterMachines = result.data
				}
			})
			.catch(error => {});
		},
		getFilterSubprocesss : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportNg.getListCustomUrl(this,'getlistfiltersubprocess' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterSubprocesss = result.data
				}
			})
			.catch(error => {});
		},
		getFilterCustomers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportNg.getListCustomUrl(this,'getlistfiltercustomer' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterCustomers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterLines : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportNg.getListCustomUrl(this,'getlistfilterline' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterLines = result.data
				}
			})
			.catch(error => {});
		},
		getFilterPartClassifications : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportNg.getListCustomUrl(this,'getlistfilterpartclassification' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterPartClassifications = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportNgFilter();
			this.getReportNgs();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportNgs();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportNg.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportNg.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportNg.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportNg.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportNgs();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportNg.deleteMultipleData(this).then(result => {
					this.getReportNgs();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportNgParent = document.getElementById('table-list-reportng').parentNode;
			tableReportNgParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportNgParent.scrollWidth - tableReportNgParent.offsetWidth) == Math.ceil(tableReportNgParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportNgParent = document.getElementById('table-list-reportng').parentNode;
			tableReportNgParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportNgParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportNgFilter();
		this.getFilterControlCardNumbers()
		this.getFilterPartNumbers()
		this.getFilterMachines()
		this.getFilterSubprocesss()
		this.getFilterCustomers()
		this.getFilterLines()
		this.getFilterPartClassifications()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Ng"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportNgs();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportNgs();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportNgs();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportNgs();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportNgs();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportNg.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportngindex") {
					this.getReportNgsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_ng").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
